import { render } from "./PersonalInfo.vue?vue&type=template&id=5950dbaf&ts=true"
import script from "./PersonalInfo.vue?vue&type=script&lang=ts"
export * from "./PersonalInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__